import { useSelector } from 'react-redux';

/**
 * 로그인 사용자가 관리자인지 - 보안 배치 2(권한, 2026-10-27). auth.user(로그인 시
 * GET /api/v1/user/info 응답, modules/auth.js가 LOGIN_SUCCESS/TEMP_SET_USER로 저장하고
 * index.js가 새로고침 시 localStorage('user')에서 복원한다)의 role 필드를 본다.
 *
 * ⚠️ 이 값은 버튼/메뉴 노출 판단용이다 - 실제 차단은 서버(AdminGuard)가 한다. 화면을 숨겨도
 * API를 직접 호출하면 서버가 403을 돌려준다.
 */
export const useIsAdmin = () => {
  const user = useSelector(({ auth }) => auth.user);
  return typeof user?.role === 'string' && user.role.toUpperCase().includes('ADMIN');
};

export default useIsAdmin;
